export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ReInspectMini-ar.5658e667.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};